import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 1D17B03B-9147-4067-8F5E-88773D68289E
 * name archive-alert-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const ArchiveAlertOutlineIcon = createSvgIcon(<><path d="M2 4H18V7H2V4M7.5 11H12.5C12.78 11 13 11.22 13 11.5V13H7V11.5C7 11.22 7.22 11 7.5 11M20 13V7H22V13H20M20 17V15H22V17H20M3 8H5V18H15V8H17V20H3V8Z" /></>, 'ArchiveAlertOutlineIcon');
export default ArchiveAlertOutlineIcon